import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useCallback } from 'react';

export const CtrtDistList = ({ ctrtObj }) => {
    
    const augRowsReq = useCallback((rowsReq) => {
        if (!ctrtObj) return;
        rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('ctrtId', ctrtObj.id));
      }, [ctrtObj.id]);

    return (
        <EntityList entity="CTRT_DIST" augRowsReq={augRowsReq} />
    )
}